module.exports = __webpack_public_path__ + "static/assets/975ad8ec85c82949bc5caa042ac96b1b.png";